var map = {
  "./da.json": [
    "43381",
    [
      53110
    ]
  ],
  "./fi.json": [
    "39791",
    [
      6116
    ]
  ],
  "./sv.json": [
    "50223",
    [
      71364
    ]
  ],
  "./ja.json": [
    "43211",
    [
      78968
    ]
  ],
  "./lt.json": [
    "16974",
    [
      61123
    ]
  ],
  "./sl.json": [
    "44049",
    [
      91114
    ]
  ],
  "./fr.json": [
    "14454",
    [
      50747
    ]
  ],
  "./es.json": [
    "57534",
    [
      71859
    ]
  ],
  "./no.json": [
    "8325",
    [
      5638
    ]
  ],
  "./cs.json": [
    "42384",
    [
      60329
    ]
  ],
  "./en.json": [
    "33269",
    [
      73078
    ]
  ],
  "./description/en.json": [
    "32946",
    [
      37071
    ]
  ],
  "./pl.json": [
    "38258",
    [
      67919
    ]
  ],
  "./hu.json": [
    "59789",
    [
      94942
    ]
  ],
  "./nl.json": [
    "66152",
    [
      64529
    ]
  ],
  "./de.json": [
    "29601",
    [
      36730
    ]
  ],
  "./pt.json": [
    "20890",
    [
      45895
    ]
  ],
  "./it.json": [
    "74127",
    [
      5156
    ]
  ],
  "./et.json": [
    "74579",
    [
      63792
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 21323;
module.exports = __rspack_async_context;
